import React from 'react';
import Slider from './Slider/Slider';
import Body from './Body/Body';
import BodySection from './Body/bodysection/BodySection';
import Bodysection2 from './Body/Section2/Bodysection2';
import BodySection4 from './Body/Bodysection4/BodySection4';
import FooterSection1 from './Footer/FooterSection1';
import Bodysection5 from './Body/bodysection5/bodysection5';
import "./home.css"

const Home = () => {
  return (
    <main className="home-container">
      <section className="hero-section">
        <Slider />
      </section>
      
      <section className="quick-actions">
        <Body />
      </section>
      
      <section className="admissions-showcase">
        <BodySection />
      </section>
      
      <section className="video-gallery">
        <Bodysection5 />
      </section>
      
      <section className="mission-statement">
        <Bodysection2 />
      </section>
      
      <section className="recruiters-showcase">
        <BodySection4 />
      </section>
      
      <footer className="site-footer">
        <FooterSection1 />
      </footer>
    </main>
  );
};

export default Home;